const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse} from 'bootstrap';
import SimpleLightbox from "simplelightbox";

require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_slider.js');
require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_woocommerce.js');

//Lightbox
let lightbox = new SimpleLightbox('.pdw-lightbox a', { /* options */});

//Drilldown menu
window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('ul.mobile-drilldown-menu li.menu-item-has-children > a').forEach(element => {
        //Create previous button
        let previous = document.createElement('span');
        element.nextElementSibling.prepend(previous);
        previous.classList.add("pdw-submenu-close");
        previous.innerHTML = element.innerHTML;
        previous.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.remove("open");
        });
        //Create open button
        let span = document.createElement('span');
        element.appendChild(span);
        span.classList.add("pdw-submenu-open");
        span.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.add("open");
            document.getElementById('pdw-mobile-menu').scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        });
    });
});

//Highlight text
window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('.pdw-reassurance-fiche-produit-text h2, .pdw-text-highlight-wrapper').forEach(element => {
        element.innerHTML = '<span class="pdw-text-highlight">' + element.innerHTML + '</span>';
    });
    document.querySelectorAll('.pdw-text-highlight-last-word').forEach(element => {
        let words = element.innerHTML.split(" ");
        if (!words[words.length - 1].includes("<") && !words[words.length - 1].includes(">")) {
            words[words.length - 1] = '<span class="pdw-text-highlight">' + words[words.length - 1] + '</span>';
            element.innerHTML = words.join(" ");
        }
    });
});

//BigText
import BigText from 'big-text.js';

window.addEventListener("DOMContentLoaded", pdwBigText);

function pdwBigText() {
    document.querySelectorAll('.pdw-bigtext').forEach(element => {
        BigText(element, {
            fontSizeFactor: 1.2,
            limitingDimension: "width"
        });
    });
}

// Function to call another function only once even if called multiple times by an event (like resize)
function pdw_call_once(func, time) {
    var time = time || 100; // 100 by default if no param
    var timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
}

function resizeContent() {
    pdwBigText();
}

window.addEventListener("resize", pdw_call_once(resizeContent, 150));